<template>
  <v-dialog
    :value="visible"
    max-width="760"
    width="760"
    content-class="premium-dialog"
    @input="onDialogInput"
  >
    <v-card v-if="pagamento" class="pa-0">
      <v-toolbar flat color="white" dense class="pt-2">
        <v-toolbar-title class="subheading font-weight-bold grey--text text--darken-2">
          AVALIAR PAGAMENTO
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="close">
          <v-icon color="grey">close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-6 pt-2 pb-5">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center mb-4 mt-2">
            <div class="headline primary--text font-weight-medium">{{ formatCurrency(pagamento.valor) }}</div>
            <div class="subheading grey--text mt-1"><strong>{{ pagamento.descricao }}</strong></div>
            <span class="status-tag mt-2" :style="{ 'background-color': getStatusColor(pagamento.status) }">
              {{ formatStatus(pagamento.status) }}
            </span>
          </v-flex>

          <v-flex xs12 class="mb-4">
            <v-layout row wrap class="detalhes-box pa-3">
              <v-flex xs12 sm6 class="mb-2">
                <div class="caption grey--text">Vencimento</div>
                <div class="body-2"><strong>{{ formatDate(pagamento.data_vencimento) }}</strong></div>
              </v-flex>
              <v-flex xs12 sm6 class="mb-2 detalhe-direita">
                <div class="caption grey--text">Solicitado por</div>
                <div class="body-2"><strong>{{ pagamento.solicitante ? pagamento.solicitante.name : '---' }}</strong></div>
              </v-flex>
              <v-flex xs12 v-if="pagamento.data_pagamento">
                <div class="caption grey--text">Pago em</div>
                <div class="body-2 verde--text text--darken-1"><strong>{{ formatDate(pagamento.data_pagamento) }}</strong></div>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
      </v-card-text>
      
      <v-divider></v-divider>

      <v-card-actions class="pa-3 dialog-actions">
        <v-btn flat large color="red" @click="confirmar('rejeitar')" class="font-weight-bold btn-rejeitar" :loading="loading" :disabled="loading">
          Rejeitar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn dark large color="secondary" class="px-5 font-weight-bold btn-acao-principal btn-autorizar" @click="confirmar('autorizar')" :loading="loading" :disabled="loading">
          <v-icon left>check_circle</v-icon> Autorizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { apiURL } from '@/config'
import { formatBRDate, formatBRLCurrency } from '@/utils/formatters'

export default {
  props: ['visible', 'pagamento'],
  data () {
    return {
      loading: false,
      colors: {
        pendente: '#EDC109',
        autorizado: '#006AB6',
        rejeitado: '#ED1B09',
        pago: '#4FBF46'
      },
      statusLabels: {
        pendente: 'Pendente',
        autorizado: 'Autorizado',
        rejeitado: 'Rejeitado',
        pago: 'Pago'
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.loading = false
      }
    }
  },
  methods: {
    formatCurrency: formatBRLCurrency,
    formatDate: formatBRDate,
    getStatusColor (status) {
      return this.colors[status] || '#9E9E9E'
    },
    formatStatus (status) {
      return this.statusLabels[status] || 'Não definido'
    },
    onDialogInput (value) {
      if (value === false && !this.loading) this.close()
    },
    close () {
      this.$emit('close')
    },
    confirmar (tipo) {
      if (this.loading) return

      this.loading = true
      this.$store.dispatch('utils/showLoading')

      let data = {
        acao_aprovacao: tipo
      }

      axios.post(`${apiURL}/pagamentos/${this.pagamento.id}`, data).then(() => {
        this.loading = false
        this.$store.dispatch('utils/hideLoading')
        this.$emit('saved')
        this.close()
        this.$store.dispatch('utils/showSnackbar', {
          type: 'success',
          text: `Pagamento ${tipo === 'autorizar' ? 'autorizado' : 'rejeitado'} com sucesso!`
        })
      }).catch((error) => {
        this.loading = false
        this.$store.dispatch('utils/hideLoading')
        let text = 'Erro ao processar ação.'
        if (error.response && error.response.data && error.response.data.error) {
          text = error.response.data.error
        }
        this.$store.dispatch('utils/showSnackbar', {
          type: 'error',
          text: text
        })
      })
    }
  }
}
</script>

<style scoped>
.detalhes-box {
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #fafafa;
}

.status-tag {
  color: #fff;
  display: inline-block;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 4px 10px;
}

.btn-acao-principal {
  box-shadow: 0 4px 14px rgba(243, 112, 33, 0.35) !important;
}

.btn-acao-principal.btn--disabled {
  box-shadow: none !important;
}

@media (max-width: 599px) {
  .detalhe-direita {
    text-align: left;
  }

  .dialog-actions {
    display: block;
  }

  .dialog-actions .spacer {
    display: none;
  }

  .dialog-actions .btn {
    width: 100%;
    margin: 0 0 8px 0 !important;
  }

  .dialog-actions .btn:last-child {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// PagamentosAprovar.vue?266623c6